export default {
  readMore: {
    id: 'hub_buying_guide_read_more_article',
    defaultMessage: 'Read more',
  },
}
